import { Box, Stack } from "@mui/material";
import React from "react";
import { allIcons } from "../../../assets";
import AppContainer from "../../../components/AppContainer";
import GlobalButton from "../../../components/CustomButton";
import DynamicTable from "../../../components/DynamicTable";
import TableData from "../../../dumyData/Notifications.json";
import NavigationDrawer from "../../../components/NavigationDrawer";

const headerData = ["Created AT", "Notificaton", "Timer", "Status"];

const tableRows = [
  "date_time",
  "notification_title",
  "notification_timer",
  "notification_send",
];

function AllNotification() {
  const handleNavigate = (row) => {
    console.log(row);
  };

  // Render top right part on template
  const renderRightPart = () => {
    return (
      <Stack
        gap={1}
        direction={"row"}
        alignItems={"center"}
        flex={1}
        justifyContent={"flex-end"}
      >
        <Box height={40}>
          <GlobalButton
            variant={"contained"}
            btnText={"Add New"}
            // handleClickBtn={() => openDialog.current.isVisible()}
            styleProps={{
              fontWeight: 400,
              fontSize: "0.875rem",
            }}
          />
        </Box>
        <img
          src={allIcons.trashIcon}
          alt="delete-icon"
          width={25}
          height={"auto"}
          style={{ cursor: "pointer" }}
        />
      </Stack>
    );
  };
  return (
    <NavigationDrawer>
      <AppContainer
        primaryHeading={"All Notification"}
        secondaryHeading={"All Client given reviews."}
        showSerach={true}
        // headProps={renderRightPart()}
        showCalenderIcon={true}
      >
        <DynamicTable
          tableHeader={headerData}
          displayRows={tableRows}
          tableData={TableData}
          handleNavigate={handleNavigate}
        />
      </AppContainer>
    </NavigationDrawer>
  );
}

export default AllNotification;
